import { Plus } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Pagination } from '@/components/common/Pagination';
import { SearchBar } from '@/components/common/SearchBar';
import { Button } from '@/components/ui/button';
import { whitelistStore } from '@/stores';
import { AddDialog } from './components/AddDialog';
import { WhitelistTable } from './components/WhitelistTable';

export const WhitelistPage = observer(() => {
  const [addDialogOpen, setAddDialogOpen] = useState(false);

  useEffect(() => {
    whitelistStore.fetchWhitelist();
  }, []);

  useEffect(() => {
    whitelistStore.fetchWhitelist();
  }, [whitelistStore.pagination.page, whitelistStore.pagination.pageSize]);

  const handleSearch = (userId: string) => {
    whitelistStore.setSearchUserId(userId);
    whitelistStore.fetchWhitelist();
  };

  return (
    <div className="bg-white rounded-lg border border-border shadow-sm">
      <div className="p-6 space-y-6">
        <div className="flex items-center justify-between">
          <h1 className="text-lg font-semibold text-foreground">白名单管理</h1>
          <Button onClick={() => setAddDialogOpen(true)}>
            <Plus className="mr-2 h-4 w-4" />
            添加
          </Button>
        </div>
        <SearchBar
          placeholder="搜索用户ID..."
          onSearch={handleSearch}
          className="max-w-md"
        />

        <div className="space-y-4">
          <WhitelistTable />
          <Pagination
            page={whitelistStore.pagination.page}
            pageSize={whitelistStore.pagination.pageSize}
            total={whitelistStore.pagination.total}
            onPageChange={(page) => {
              whitelistStore.setPagination(page);
            }}
          />
        </div>
      </div>

      <AddDialog open={addDialogOpen} onOpenChange={setAddDialogOpen} />
    </div>
  );
});
